import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { Porder } from 'src/app/assabil-sales/models/entities/porder';
import { ProcurementService } from 'src/app/assabil-sales/services/procurement.service';
import { PorderLine } from 'src/app/assabil-sales/models/entities/porder-line';
import { WarehouseTransfer } from 'src/app/assabil-sales/models/entities/warehouse-transfer';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { WarehouseTransferRequest } from 'src/app/assabil-sales/models/entities/warehouse-transfer-request';
import { PorderPipe } from 'src/app/assabil-sales/pipes/porder-pipe';
import { ConfigService } from 'src/app/tools/services/config.service';
import { WarehouseTransferType } from 'src/app/assabil-sales/enums/warehouse-transfer-type';
import { SalesReportsService } from 'src/app/assabil-sales/services/sales-reports-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
 

@Component({
    selector: 'porder-widget',
    templateUrl: './porder-widget.component.html',
    styleUrls: ['./porder-widget.component.scss']
})



export class PorderWidgetComponent extends BaseWidget  {


  porderPipe            : PorderPipe = new PorderPipe();
  
  porder               : Porder = new Porder();
  porderLineColumns   = [];
  enteredOnly           : boolean = true;


  qColumns  = [
                {'label' : 'Qté commandée',   readOnly : false, background :'#eef5fb'}, 
                {'label' : 'Qté livrée'   ,   readOnly : true, background :'white' }
              ];
 

  constructor(
    public    masterDataService : MasterDataService,
    protected procurementService: ProcurementService,
    protected toastr            : ToastrService,
    protected leanUtilsService  : LeanUtilsService,
    protected configService     : ConfigService,
    protected salesReportsService: SalesReportsService,
    public    userService       : UserService) {
    super(toastr, leanUtilsService);
  }


 //--------------------------------------------------------------------------------------------------------
 setEntity(porder: Porder) {
   
  this.porder = porder;
  if (porder.inserted) this.enteredOnly = false

  if (porder.returnPo) {
    this.qColumns  = [
      {'label' : 'Retour Demandé',           readOnly : false, background :'#eef5fb'},  
      {'label' : 'Retour Endommagé Demandé', readOnly : false, background :'#faeeee'}, 
      {'label' : 'Retour Périmé Demandé',    readOnly : false, background :'#f0dede'}, 

      {'label' : 'Retour Validé',            readOnly : true , background :'#eef5fb'}, 
      {'label' : 'Retour Endommagé Validé',  readOnly : true , background :'#faeeee'}, 
      {'label' : 'Retour Périmé Validé',     readOnly : true , background :'#f0dede'}, 
    ];
  }


   this.masterDataService.loadProductPages(3, true).then(res => {

      if (porder.porderLines) {
        for (let porderLine of porder.porderLines) {
          for (let pp of this.masterDataService.salableProductPages) {
            for (let product of pp.products) {
              if (product.productCode == porderLine.product.productCode) {
                
                if (! porder.returnPo) {
                  product.quantityL[0] = this.leanUtilsService.zeroToNull(Math.floor(porderLine.quantity / product.purchasePacking)); 
                  product.quantityP[0] = this.leanUtilsService.zeroToNull(Math.floor( (porderLine.quantity % product.purchasePacking) / product.loadPacking)); 
                  product.quantityU[0] = this.leanUtilsService.round(porderLine.quantity -  (this.leanUtilsService.nullToZero(product.quantityL[0]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[0]) * product.loadPacking), product.decimalPrecision);
                } else {
                  product.quantityL[0] = this.leanUtilsService.zeroToNull(Math.floor(porderLine.returnedQuantity / product.purchasePacking)); 
                  product.quantityP[0] = this.leanUtilsService.zeroToNull(Math.floor((porderLine.returnedQuantity % product.purchasePacking) / product.loadPacking)); 
                  product.quantityU[0] = this.leanUtilsService.round(porderLine.returnedQuantity -  (this.leanUtilsService.nullToZero(product.quantityL[0]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[0]) * product.loadPacking), product.decimalPrecision);
 
                  product.quantityL[1] = this.leanUtilsService.zeroToNull(Math.floor(porderLine.returnedDamagedQuantity1 / product.purchasePacking)); 
                  product.quantityP[1] = this.leanUtilsService.zeroToNull(Math.floor((porderLine.returnedDamagedQuantity1 % product.purchasePacking) / product.loadPacking)); 
                  product.quantityU[1] = this.leanUtilsService.round(porderLine.returnedDamagedQuantity1 -  (this.leanUtilsService.nullToZero(product.quantityL[1]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[1]) * product.loadPacking), product.decimalPrecision);
 
                  product.quantityL[2] = this.leanUtilsService.zeroToNull(Math.floor(porderLine.returnedDamagedQuantity2 / product.purchasePacking)); 
                  product.quantityP[2] = this.leanUtilsService.zeroToNull(Math.floor((porderLine.returnedDamagedQuantity2 % product.purchasePacking) / product.loadPacking)); 
                  product.quantityU[2] = this.leanUtilsService.round(porderLine.returnedDamagedQuantity2 -  (this.leanUtilsService.nullToZero(product.quantityL[2]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[2]) * product.loadPacking), product.decimalPrecision);
                }

                pp.expand = true;
                break;
              }
            }
          }
        }

        for (let porderDelivery of porder.porderDeliveries) {
          for (let pp of this.masterDataService.salableProductPages) {
            for (let product of pp.products) {
              if (product.productCode == porderDelivery.productCode) {
                if (! porder.returnPo) {
                  product.quantityL[1] = Math.floor(porderDelivery.quantity / product.purchasePacking);
                  product.quantityP[1] = Math.floor((porderDelivery.quantity % product.purchasePacking) / product.loadPacking);  
                  product.quantityU[1] = porderDelivery.quantity -  (this.leanUtilsService.nullToZero(product.quantityL[1]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[1]) * product.loadPacking);
                } else {   
                  product.quantityL[3] = Math.floor(porderDelivery.returnedQuantity / product.purchasePacking);
                  product.quantityP[3] = Math.floor((porderDelivery.returnedQuantity % product.purchasePacking) / product.loadPacking);  
                  product.quantityU[3] = porderDelivery.returnedQuantity -  (this.leanUtilsService.nullToZero(product.quantityL[3]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[3]) * product.loadPacking);   
                  
                  product.quantityL[4] = Math.floor(porderDelivery.returnedDamagedQuantity1 / product.purchasePacking);
                  product.quantityP[4] = Math.floor((porderDelivery.returnedDamagedQuantity1 % product.purchasePacking) / product.loadPacking);  
                  product.quantityU[4] = porderDelivery.returnedDamagedQuantity1 -  (this.leanUtilsService.nullToZero(product.quantityL[4]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[4]) * product.loadPacking);                 

                  product.quantityL[5] = Math.floor(porderDelivery.returnedDamagedQuantity2 / product.purchasePacking);
                  product.quantityP[5] = Math.floor((porderDelivery.returnedDamagedQuantity2 % product.purchasePacking) / product.loadPacking);  
                  product.quantityU[5] = porderDelivery.returnedDamagedQuantity2 -  (this.leanUtilsService.nullToZero(product.quantityL[5]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[5]) * product.loadPacking);                 

                }
                pp.expand = true;
                break;
              }
            }
          }
        }
      }
      
   })
  }
 //--------------------------------------------------------------------------------------------------------

  //--------------------------------------------------------------------------------------------------------
  getEntity(){
    return this.porder;
  }
  //--------------------------------------------------------------------------------------------------------

  closePorder(){
        this.procurementService.porderClose(this.porder.porderCode).then(res => {
          this.porder = res; 
          this.leanUtilsService.success();
          return;
      })
  }

  //--------------------------------------------------------------------------------------------------------
  saveRow() : Promise<Porder>{
    
    this.enteredOnly = true;

    let newPorderLines : PorderLine[] = [];

    for (let pp of this.masterDataService.salableProductPages) {
      for (let product of pp.products) {
        let found : boolean = false;
        for (let porderLine of this.porder.porderLines) {
          if (product.productCode == porderLine.product.productCode) {
            found = true;
            if ( (! product.quantityL[0]) &&(! product.quantityP[0]) && (! product.quantityU[0]) 
              && (! product.quantityL[1]) &&(! product.quantityP[1]) && (! product.quantityU[1]) 
              && (! product.quantityL[2]) &&(! product.quantityP[2]) && (! product.quantityU[2]) ) {
              porderLine.deleted = true;
            } else {
              if (! this.porder.returnPo) {
                porderLine.quantity = this.getQuantity(product, 0);
              } else {
                porderLine.returnedQuantity        = this.getQuantity(product, 0);
                porderLine.returnedDamagedQuantity1= this.getQuantity(product, 1);
                porderLine.returnedDamagedQuantity2= this.getQuantity(product, 2);   
              }
             }
            break;
          }
        }
        if ( (! found) && (   product.quantityL[0]  || product.quantityP[0]  || product.quantityU[0]   
                           || product.quantityL[1]  || product.quantityP[1]  || product.quantityU[1] 
                           || product.quantityL[2]  || product.quantityP[2]  || product.quantityU[2]) ) {
          let newPorderLine : PorderLine = new PorderLine();
          newPorderLine.inserted            = true;
          newPorderLine.product             = new Product();
          newPorderLine.product.productCode = product.productCode;
          if ( ! this.porder.returnPo) {
            newPorderLine.quantity                 = this.getQuantity(product, 0); 
          } else {
            newPorderLine.returnedQuantity         = this.getQuantity(product, 0);
            newPorderLine.returnedDamagedQuantity1 = this.getQuantity(product, 1);
            newPorderLine.returnedDamagedQuantity2 = this.getQuantity(product, 2);
          } 
          newPorderLines.push(newPorderLine);
        }
      }
    }

    for (let newPorderLine of newPorderLines){
      this.porder.porderLines.push(newPorderLine);
    }

    return this.procurementService.porderSave(this.porder);
  }
  //--------------------------------------------------------------------------------------------------------


  edit(b  : boolean) {

    if ( b ) {
      this.porder.edit    = true;
      this.porder.updated = true;
      return;
    }
      

    // We are leaving edit mode by Update cancelation or  Create cancelation
    
    // Create cancelation
    if (this.porder.inserted){
      this.close();
      return;
    } 

    // Update cancelation
    this.procurementService.porderGet(this.porder.porderCode).then(res => {
        this.porder = res; 
        return;
    })

  }

receptionMode : boolean = false;
warehouseTransfer : WarehouseTransfer

newWarehouseTransfer(){
    let tmp : Porder = new Porder();
    tmp.porderCode = this.porder.porderCode;
    this.warehouseTransfer                  = new WarehouseTransfer();
    this.warehouseTransfer.porder           = tmp;
    this.warehouseTransfer.requestedForRole = new Role();
    this.warehouseTransfer.confirmedByRole  = new Role();
    this.warehouseTransfer.transferType     = WarehouseTransferType.tt_purchase;
    this.warehouseTransfer.progressLevel    = 10;           // submited to warehouse keeper  
    this.warehouseTransfer.returnWt         = this.porder.returnPo;
    this.warehouseTransfer.inserted         = true;

    this.warehouseTransfer.warehouseTransferRequests = [];
    if (this.porder.porderLines) {
      for (let pol of this.porder.porderLines){
          let warehouseTransferRequest                  : WarehouseTransferRequest = new WarehouseTransferRequest();
          warehouseTransferRequest.product              = new Product();
          warehouseTransferRequest.product.productCode  = pol.product.productCode;

          if (! this.porder.returnPo) {
            warehouseTransferRequest.confirmedQuantity          = pol.quantity ;
            //warehouseTransferRequest.confirmedDamagedQuantity1  = 0;
            warehouseTransferRequest.movedQuantity1             = pol.quantity ;
          } else {

            warehouseTransferRequest.confirmedReturnedQuantity          = pol.returnedQuantity ;
            warehouseTransferRequest.confirmedReturnedDamagedQuantity1  = pol.returnedDamagedQuantity1 ;
            warehouseTransferRequest.confirmedReturnedDamagedQuantity2  = pol.returnedDamagedQuantity2 ;  

            warehouseTransferRequest.movedQuantity2                     = pol.returnedQuantity ;
            warehouseTransferRequest.movedQuantity3                     = pol.returnedDamagedQuantity1 ;
            warehouseTransferRequest.movedQuantity4                     = pol.returnedDamagedQuantity2 ;  
          }
          this.warehouseTransfer.warehouseTransferRequests.push(warehouseTransferRequest);
        }
    }

    if (this.porder.porderDeliveries) {
      for (let porderDelivery of this.porder.porderDeliveries) {
        for (let wtr of this.warehouseTransfer.warehouseTransferRequests) {
          if (wtr.product.productCode == porderDelivery.productCode){

            wtr.movedQuantity1 =  wtr.movedQuantity1 - porderDelivery.quantity;
            if (wtr.movedQuantity1 <0) wtr.movedQuantity1 = 0;

            //xxxxx

          }
        }
      }
    }

    this.receptionMode = true;
  }

  exitReceptionMode(){
    this.receptionMode = false;

    // In order to reinit ProductPages.product fields
    this.setEntity(this.porder);
  }


  //------------------------------------------------------------------------------------------------------------
  getQuantity(product: Product, index: number): number {
    let l = product.quantityL[index] ? product.quantityL[index]  : 0;
    let p = product.quantityP[index] ? product.quantityP[index]  : 0;
    let u = product.quantityU[index] ? product.quantityU[index]  : 0;
    return (l * product.purchasePacking) + (p * product.loadPacking) + u;
  }
  //------------------------------------------------------------------------------------------------------------


 //---------------------------------------------------------------------------------------
 print(){
   this.salesReportsService.porderPrint(this.porder.porderCode)
  }

  

}

